import { loadTemplate } from "utils/load_template"
import SelectRefinementWidget from 'components/algolia/select_refinement_widget'
import DistinctRefinementWidget from 'components/algolia/distinct_refinement_widget'

export function practiceAreasWidget({ showCounters }) {
  return new DistinctRefinementWidget({
    connector: instantsearch.connectors.connectRefinementList,
    showCounters: showCounters,
    facetCounterAttribute: "practice_areas"
  }).widget({
    attribute: "practice_areas",
    operator: "or",
    limit: 500,
    container: "practice_areas",
    templates: {
      item: loadTemplate(showCounters ? "cle_practice_areas_filter_template_with_counters" : "cle_practice_areas_filter_template")
    },
    cssClasses: {
      root: "scrollable"
    },
    sortBy: ["name:asc"]
  })
}

export function practiceAreasMobileWidget() {
  return new SelectRefinementWidget({ selectType: "multiple" }).widget({
    attribute: "practice_areas",
    limit: 500,
    container: "practice_areas_mobile",
    sortBy: ["name:asc"]
  })
}
